import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';

export default class ReviewsStateForPeriod {
	companyHotelId: number;
	from: string | null;
	to: string | null;
	competitorReviewsStates: CompetitorReviewsState[] = [];

	constructor(data: ReviewsStateForPeriod) {
		Object.assign(this, data);
		this.competitorReviewsStates = data.competitorReviewsStates
			? data.competitorReviewsStates.map(item => new CompetitorReviewsState(item))
			: [];
	}

	public findMainHotelState(): CompetitorReviewsState | undefined {
		return this.competitorReviewsStates.find(item => item.isMainHotel);
	}

	public findCompetitorStates(): CompetitorReviewsState[] {
		return this.competitorReviewsStates.filter(item => item.isCompetitor);
	}

	get rank() {
		const rankedStates = [...this.competitorReviewsStates]
			.sort((a, b) => (b.statistics.score ?? 0) - (a.statistics.score ?? 0));
		const mainHotelRankIndex = rankedStates.findIndex(c => c.isMainHotel);
		return mainHotelRankIndex >= 0 ? mainHotelRankIndex + 1 : 0;
	}
}
